import { useEffect, useState } from "react";
import ForeCasterInfoBase from "./ForeCasterInfoBase";
import { useDispatch, useSelector } from "react-redux";
import { CheckPermissions } from "../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import {
  selectUserData,
  selectUserToken,
  setDisplayErrorSnackBar,
} from "../../../../../features/userSlice";
import Page404 from "../../../../Page404/Page403";
import { useSearchParams } from "react-router-dom";
import { forecastersEndPointLogic } from "../../../../../logic/AssetManagement/Forecasters/forecastersEndPointLogic";
import store from "../../../../../store";
import FTDInfo from './FTDInfo';
import GrowthInfo from './GrowthInfo';
import ProfitInfo from './ProfitInfo';
import ForecastSkeleton from "../CreateNewForeCast/ForecastSkeleton";
import { Paper } from "@mui/material";

const ForeCasterInfo = () => {
  const response = useSelector(selectUserData);

  const hasViewForcastersHistoryPermission = CheckPermissions(
    response?.data?.products?.assets,
    "overview",
    "view_forecasters_history"
  );
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const selectedSite = searchParams.get("selectedSite") as any;
  const selectedYear = searchParams.get("selectedYear");
  const selectedMetaSharedUid = searchParams.get("metaSharedUid");
  const templateType = searchParams.get("templateType");
  const forecastersList = useSelector(
    (state: any) => state.forecasters?.forecastersList
  );
  const selectedForecaster = forecastersList?.find(
    (forecaster: any) => forecaster.meta_shared_uid === selectedMetaSharedUid
  );
  const [dataLoaded, setDataLoaded] = useState(false);
  const [showContent, setShowContent] = useState(false);

  const ComponentMap:any = {
    FTD: FTDInfo,
    Growth: GrowthInfo,
    Profit: ProfitInfo
  };

  const renderComponent = (type: string) => {
    const Component = ComponentMap[type || ''];
    return Component ? <Component selectedForecaster={selectedForecaster} onTableReady={() => setShowContent(true)} showContent={showContent} /> : null;
  };

  useEffect(() => {
    if (selectedSite && selectedYear) {
      setIsLoading(true);
      setDataLoaded(false);
      setShowContent(false);
      const fetchForecastData = async () => {
        try {
          await forecastersEndPointLogic.getForecastersList(
            selectedSite,
            oauthTokenHeader,
            selectedYear,
            dispatch
          );
          setDataLoaded(true); // Set dataLoaded to true only after successful data fetch
        } catch (error: any) {
          store.dispatch(
            setDisplayErrorSnackBar({
              message:
                error?.parsedText ||
                "Error while fetching data. Please try again later.",
              type: "error",
            })
          );
        } finally {
          setIsLoading(false);
        }
      };
      fetchForecastData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSite, selectedYear, dispatch]);

  return (
    <>
      {hasViewForcastersHistoryPermission ? (
        <>
          {isLoading ? <ForecastSkeleton /> : ""}
          {dataLoaded && !isLoading && (
            <Paper elevation={0} sx={{ borderRadius: 0, position: "relative"}}>
              {showContent && (<ForeCasterInfoBase selectedForecaster={selectedForecaster} />)}
              {renderComponent(templateType || '')}
            </Paper>
          )}
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default ForeCasterInfo;
